import { handleTrack } from '../../../../utils/tracker';

interface IBuyNow {
  href: string;
  funnelMetricLabel: string;
  className?: string;
  id?: string;
}

export const BuyNow: React.FC<IBuyNow> = ({
  href,
  funnelMetricLabel,
  className = '',
  id,
}) => {
  return (
    <a
      id={id}
      href={href}
      className={`text-white px-12 py-3  bg-blue-350 font-bold rounded-md block text-center ${className} sm:ml-0 sm:my-2`}
      onClick={(e) => handleTrack({ label: funnelMetricLabel, obj: e.target })}
    >
      {'Buy Now'}
    </a>
  );
};
